import { createSlice } from '@reduxjs/toolkit'
import { listUIInitialState } from '@utils/constants/requestConstants'
import { listUIReducers, directoryReducers } from '../reducers'

const companyPopulates = [
    { path: 'contacts', select: 'tel email' },
    { path: 'country', select: 'name' }
]
const contactPopulates = [
    { path: 'country', select: 'name' },
    // { path: 'city', select: 'name' },
    { path: 'company', select: '_id name logo sectors demandingSectors userType' }
]

const publishedDirectorySlice = createSlice({
    name: 'ui/published-directory',
    initialState: {
        ...listUIInitialState,
        searchType: 'elastic',
        expandedContactKeys: [],
        expandedContactTreeKeys: [],
        expandedRowKeys: [],
        filters: { ...listUIInitialState.filters, userType: 'all', sourceNames: 'all' },
        openSideFilter: false,
        pureFilters: { ...listUIInitialState.pureFilters, userType: 'all', sourceNames: 'all' },
        populates: contactPopulates,
        excluded: {},
        totalContacts: 0,
        totalCompanies: 0,
        totalContactsStatus: 'idle',
        totalCompaniesStatus: 'idle'
    },
    reducers: {
        ...listUIReducers,
        onResetFilters(state) {
            state.filters = { userType: 'all', sourceNames: 'all' }
            state.pureFilters = { userType: 'all', sourceNames: 'all' }
        },
        changeSideFilterVisibility(state, action) {
            state.openSideFilter = action.payload
        },
        onChangeTab(state, action) {
            if (action.payload === 'contacts') {
                // state.filters = { ...state.filters, userType: 'all', sourceNames: 'all' }
                // state.pureFilters = { ...state.pureFilters, userType: 'all', sourceNames: 'all' }
                state.populates = contactPopulates
            } else {
                const newFilters = { ...state.filters }
                const newPureFilters = { ...state.pureFilters }
                delete newFilters.userType
                delete newPureFilters.userType
                // state.filters = newFilters
                // state.pureFilters = newPureFilters
                state.populates = companyPopulates
            }
        },
        onChangeTotalData(state, action) {
            Object.keys(action.payload).map(key => {
                state[key] = action.payload[key]
            })
        },
        ...directoryReducers
    }
})

export const publishedDirectoryActions = publishedDirectorySlice.actions
export default publishedDirectorySlice.reducer
